export interface JSONObject {
  [key: string]: string | number | boolean | null | undefined | JSONObject;
}

export function sort(json: JSONObject) {
  const result: JSONObject = {};
  if (typeof json === "object" && json !== null) {
    Object.keys(json)
      .sort()
      .forEach((key: string) => {
        result[key] = json[key];
        if (typeof result[key] === "object" && result[key] !== null) {
          result[key] = sort(result[key] as JSONObject);
        }
      });
  }
  return result;
}

export function unflatten(jsonTable: { [key: string]: string }): JSONObject {
  if (jsonTable) {
    const result: Record<string, any> = {};
    Object.keys(jsonTable).forEach((key: string) => {
      const namespaces: string[] = key.split(".");
      const lastIndex: number = namespaces.length - 1;
      let current: { [key: string]: any } = result;
      namespaces.forEach((namespace: string, index: number) => {
        if (!current.hasOwnProperty(namespace)) {
          current[namespace] = index === lastIndex ? jsonTable[key] : {};
        }
        if (typeof current[namespace] === "object") {
          current = current[namespace];
        }
      });
    });
    return sort(result);
  }
  return jsonTable;
}

export function flatten(json: { [key: string]: any }, parentKey: string = "") {
  if (typeof json === "object" && json !== null) {
    let result: Record<string, string> = {};
    Object.keys(json).forEach((key: string) => {
      const combinedKey: string = parentKey ? `${parentKey}.${key}` : key;
      if (typeof json[key] !== "object" || json[key] === null) {
        result = {
          ...result,
          [combinedKey]: json[key],
        };
      } else {
        result = {
          ...result,
          ...flatten(json[key], combinedKey),
        };
      }
    });
    return result;
  }
  return json;
}

// JSON.parse làm tròn số nguyên quá 2^53 (ID end user là số 18 chữ số: 691910174964711424 → 691910174964711400).
// Giữ các số đó ở dạng chuỗi trước khi parse. Chuỗi trả về không phải JSON (hoặc rỗng) thì giữ nguyên như axios mặc định.
export function parseJsonKeepBigInts(data: unknown) {
  if (typeof data !== "string" || data.trim() === "") return data;
  const quoted = data.replace(/([:[,]\s*)(-?\d{16,})(?=\s*[,\]}])/g, (match, prefix: string, digits: string) =>
    Number.isSafeInteger(Number(digits)) ? match : `${prefix}"${digits}"`
  );
  try {
    return JSON.parse(quoted);
  } catch {
    // Thay thế chạm vào giữa một chuỗi văn bản làm JSON hỏng: parse bản gốc.
    try {
      return JSON.parse(data);
    } catch {
      return data;
    }
  }
}
